'use strict';

/* Components */
import NiftyUpcomingEvents from './upcoming-events/upcoming-events.component';
import NiftyImageContactBlock from './image-contact-block/image-contact-block.component';
import NiftyNewsWidget from './news-widget/news-widget.component';
import NiftyDocumentsWidget from './documents-widget/documents-widget.component';

export default angular.module('conduuApp.nifty', [NiftyImageContactBlock, NiftyUpcomingEvents, NiftyNewsWidget,
  NiftyDocumentsWidget])
  .name;



// WEBPACK FOOTER //
// ./client/components/nifty/index.js